export const servicePath = "https://api.gharpar.co";
export const GtmId = "GTM-PHSFZ88";
